import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import getCurrentWorkoutSelect from '../get-current'
import { createSelector } from 'reselect'

const isRecommendedWorkoutSelect = createSelector(getCurrentWorkoutSelect,
  (instance) => {
    return (
      !!getValueReduxUtil(instance, WORKOUT_KEY.RECOMMENDED_AT)
    )
  }
)

export default isRecommendedWorkoutSelect
